import { Container, Stack, Tabs } from "@mui/material";
import * as React from 'react';
import  { useState, SyntheticEvent } from "react";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import ProcessOrders from "./ProcessOrders";
import FinishedOrders from "./FinishedOrders";
import PausedOrders from "./PausedOrders";
import "../../../css/order.css"
import { Order, OrderInquiry } from "../../../lib/types/order";
import { setFinishedOrders, setPausedOrders, setProcessOrders } from "./slice";
import { Dispatch } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import { OrderStatus } from "../../../lib/enums/order.enum";
import OrderService from "../../services/OrderService";
import { useGlobals } from "../../hooks/useGlobal";
import { useHistory } from "react-router-dom";
import { serverApi } from "../../../lib/config";
import { MemberType } from "../../../lib/enums/member.enum";


//REDUX SLICE & SELECTOR
const actionDispatch = (dispatch: Dispatch) => ({
  setPausedOrders: (data: Order[]) => dispatch(setPausedOrders(data)),
  setProcessOrders: (data:Order[]) => dispatch(setProcessOrders(data)),
  setFinishedOrders: (data: Order[]) => dispatch(setFinishedOrders(data)),
})

export default function OrdersPage() {
  const { setPausedOrders, setProcessOrders,setFinishedOrders} = 
  actionDispatch(useDispatch());
   const {orderBuilder, authMember} = useGlobals();
   const history = useHistory();
   const [value, setValue] = useState('1');
   const [orderInquiry, setOrderInquiry] = useState<OrderInquiry>({
    page:1,
    limit:5,
    orderStatus: OrderStatus.PAUSE,
   })

   React.useEffect(() => {
    const order = new OrderService()

    order
      .getMyOrders({ ...orderInquiry, orderStatus: OrderStatus.PAUSE})
      .then((data) => setPausedOrders(data))
      .catch((err) => console.log(err))

     order
      .getMyOrders({ ...orderInquiry, orderStatus: OrderStatus.PROCESS})
      .then((data) => setProcessOrders(data))
      .catch((err) => console.log(err))  

     order
      .getMyOrders({ ...orderInquiry, orderStatus: OrderStatus.FINISH})
      .then((data) => setFinishedOrders(data))
      .catch((err) => console.log(err)) 
   }, [orderInquiry, orderBuilder])


  const handleChange = (e: SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  if(!authMember) history.push("/")
  return (
    <div className={"order-page"}>
    <Container className={"order-container"}>
      <Stack className={"order-left"}>
       <TabContext value={value}>
        <Box className = {"order-nav-frame"}>
          <Box sx={{borderBottom:1, borderColor: "divider"}}>
             <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic-tabs-example"
                className={"table_list"}
                >
                  <Tab label="PAUSED ORDERS" value={"1"} iconPosition="start"/>
                  <Tab label="PROCESS ORDERS" value={"2"} iconPosition="start"/>
                  <Tab label="FINISHED ORDERS" value={"3"} iconPosition="start"/>
             </Tabs>
          </Box>
        </Box>
        <Stack className={"order-main-content"}>
          <PausedOrders setValue = {setValue}/>
          <ProcessOrders setValue = {setValue}/>
          <FinishedOrders/>
        </Stack>
       </TabContext>
     </Stack>
     <Stack className={"order-right"}>
      <Box className = {"order-info-box"}>
        <Box className = {"member-box"}>
          <div className={"order-user-img"}>
             <img 
               src={authMember?.memberImage
                   ? `${serverApi}/${authMember?.memberImage}`
                   : "/icons/default-user.svg"}
               className={"order-user-avatar"}
             />
             <div className={"order-user-icon-box"}>
               <img 
                  src={authMember?.memberType === MemberType.ADMIN
                                      ? "/icons/booclub.svg"
                                      : "/icons/user-badge.svg"}
                  className={"order-user-prof-img"} />
             </div>
          </div>
          <span className={"order-user-name"}>{authMember?.memberNick}</span>
          <span className={"order-user-prof"}>{authMember?.memberType}</span>
        </Box>
        <Box className = {"liner"}></Box>
        <div className={"order-user-address"} style={{width:"90%", display:"flex", flexDirection:"row"}}>
          <img src="/icons/location.svg" alt="" />
          <div className="spec-address-txt"> {
                authMember?.memberAddress 
                   ? authMember.memberAddress 
                   :"Address not provided"}</div>
        </div>
      </Box>

       <Stack className={"order-user-card-frame"}>
                    <Stack className={"order-user-card-inputs"}>
                        <input type="text" name="cardNumber" placeholder={"Card number : **** 4090 2002 7495"}
                        className={"card-input"} />
                        <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", marginTop: 10}}>
                            <input                 
                            type={"text"}
                            name={"cardPeriod"}
                            placeholder={"07 / 24"}
                            className={"card-half-input"}/>
                            <input
                            type={"text"}
                            name={"cardCVV"}
                            placeholder={"CVV : 010"}
                            className={"card-half-input"}/>
                        </div>
                        <input
                        type={"text"}
                        name={"cardCreator"}
                        placeholder={"Cardholder Name"}
                        className={"card-input"}/>
                    </Stack>
                    <Stack className={"order-user-card-cardbox"} sx={{}}>
                        <img src="icons/western-card.svg" alt="" />
                        <img src="icons/master-card.svg" alt="" />
                        <img src="icons/paypal-card.svg" alt="" />
                        <img src="icons/visa-card.svg" alt="" />
                    </Stack>
                </Stack>
     </Stack>
    <Stack>

    </Stack>
    </Container>
     </div> 
  )

}



